export const SET_INDICATOR = 'SET_INDICATOR';
